<template>
  <div
    class="absolute flex flex-col w-full h-full bg-lightgray-lightest z-50 pt-12"
  >
    <i
      class="fal fa-times absolute top-0 right-0 text-4xl text-red mt-3 mr-4"
      @click="closeMobileNav()"
    />
    <router-link
      class="mobile-nav-item"
      :to="getLinkInformation(item).path"
      @click.native="closeMobileNav()"
      :key="item"
      v-for="item in navItems"
    >
      {{ getLinkInformation(item).name }}
    </router-link>
    <a class="mobile-nav-item logout-item" @click="logOut">
      Log Out
    </a>
  </div>
</template>

<script>
import routes from "../../route-files/routes";
import { logout } from "../../helpers";

export default {
  name: "MobileMenu",
  computed: {
    userType() {
      return this.$store.state.userType;
    },
    navItems() {
      if (this.userType === "admin") {
        return [
          "dashboard",
          "projects",
          "contacts",
          "crews",
          "items",
          "settings"
        ];
      }
      if (this.userType === "designer") {
        return ["dashboard", "projects", "settings"];
      }
      return ["dashboard", "settings"];
    }
  },
  methods: {
    closeMobileNav() {
      this.$store.commit("setIsMobileNavOpen", false);
    },
    getLinkInformation(item) {
      if (!item) {
        return {};
      }

      if (!routes) {
        return {};
      }

      return routes.find(
        route => route.name.toLowerCase() === item.toLowerCase()
      );
    },
    logOut() {
      logout(this);
      this.closeMobileNav();
    }
  }
};
</script>

<style lang="scss" scoped>
.mobile-nav-item {
  @apply uppercase text-xl px-6 py-4;
  &:not(:last-child) {
    @apply border-b border-lightgray;
  }
}
</style>
